import axios from "axios";
import { getHeaders } from "../shared";
import {
  URL,
  BROWSERSTACK_API_URL,
  BROWSERSTACK_API_UNAME,
  BROWSERSTACK_API_KEY,
} from "../constants";

const DataService = {
  assignStimToCachePgStep: async (params, done) => {
    const { studyId, cellId, step, position, stimId } = params
    try {
      const response = await axios({
        method: "post",
        url: `${URL}/v1.0/studies/${studyId}/cell/${cellId}/step/${step}/ad_slot/${position}/stim/${stimId}/create`,
        headers: getHeaders().headers,
      });
      return response
    } catch (error) {

    } finally {
      done()
    }

  },



  assignStylingToCachePgStep: async (params, styling) => {
    const { studyId, cellId, cachePgStep } = params

    try {
      const response = await axios({
        method: "post",
        url: `${URL}/v1.0/studies/${studyId}/cell/${cellId}/step/${cachePgStep}/styling`,
        headers: getHeaders().headers,
        data: styling,
      });
      return response
    } catch (error) {
      console.log('error setting styling')
      console.log(error)
      console.log('---')

    }
  },

  getStimBrands: async () => {
    try {

      const response = await axios({
        method: "get",
        url: `${URL}/v1.0/dashboard/data/brands_list`,
        headers: getHeaders().headers,
      });
      return response
    } catch (error) {
      console.log('error ')
      console.log(error)
      console.log('---')
    } finally {
    }
  },

  getStimLanguages: async () => {
    try {

      const response = await axios({
        method: "get",
        url: `${URL}/v1.0/dashboard/data/studylanguages_list/`,
        headers: getHeaders().headers,
      });
      return response
    } catch (error) {
      console.log('error ')
      console.log(error)
      console.log('---')
    } finally {
    }
  },

  getStimCountries: async () => {
    try {

      const response = await axios({
        method: "get",
        url: `${URL}/v1.0/dashboard/data/projectlocations_list/`,
        headers: getHeaders().headers,
      });
      return response
    } catch (error) {
      console.log('error ')
      console.log(error)
      console.log('---')
    } finally {
    }
  },

  // ad type groups as stim search options - distinct from getAdTypeGroups below,
  // which backs the admin lookup table and hits adtypegroups_list
  getStimAdTypeGroups: async () => {
    try {

      const response = await axios({
        method: "get",
        url: `${URL}/v1.0/dashboard/data/stim_adtypegroups_list/`,
        headers: getHeaders().headers,
      });
      return response
    } catch (error) {
      console.log('error ')
      console.log(error)
      console.log('---')
    }
  },

  updateStimOnCachePgAdslot: async (params, done) => {
    const { studyId, cellId, step, position, stimId } = params
    try {

      const response = await axios({
        method: "post",
        url: `${URL}/v1.0/studies/${studyId}/cell/${cellId}/step/${step}/ad_slot/${position}/stim/${stimId}/update`,
        headers: getHeaders().headers,
      });
      return response
    } catch (error) {
      console.log('error ')
      console.log(error)
      console.log('---')
    } finally {
      done()
    }

  },

  assignStimToCachePgStep: async (params, done) => {
    const { studyId, cellId, step, position, stimId } = params
    try {
      const response = await axios({
        method: "post",
        url: `${URL}/v1.0/studies/${studyId}/cell/${cellId}/step/${step}/ad_slot/${position}/stim/${stimId}/create`,
        headers: getHeaders().headers,
      });
      return response
    } catch (error) {
      console.log('error ')
      console.log(error)
      console.log('---')
    } finally {
      done()
    }

  },

  fetchAttentionResponseData: (data, studyId) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${studyId}/compare_report/overall_attention`,
      data: data,
      headers: getHeaders().headers,
    });
  },

  fetchAllStudyData: (data) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies`,
      data: data,
      headers: getHeaders().headers,
    });
  },

  fetchTotalInfo: () => {
    return axios({
      method: "get",
      url: `${URL}/v1.0/studies/overview`,
      headers: getHeaders().headers,
    });
  },

  fetchGraphResponseData: (data, studyId) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${studyId}/compare_report/graph2_data`,
      data: data,
      headers: getHeaders().headers,
    });
  },
  fetchFeatureResponseData: (data, studyId) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${studyId}/compare_report/feature_attention`,
      data: data,
      headers: getHeaders().headers,
    });
  },

  fetchVisualResponseData: (data, studyId) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${studyId}/compare_report/visual_data`,
      data: data,
      headers: getHeaders().headers,
    });
  },
  fetchKpiData: (studyId, cellId, stepId, stimId, filterData) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${studyId}/cell/${cellId}/step/${stepId}/stimuli/${stimId}/kpi_analysis`,
      headers: getHeaders().headers,
      data: filterData,
    });
  },
  fetchKpiGraphData: (studyId, cellId, stepId, stimId, filterData) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${studyId}/cell/${cellId}/step/${stepId}/stimuli/${stimId}/graph2_data`,
      headers: getHeaders().headers,
      data: filterData,
    });
  },
  fetchKpiRawData: (studyId, cellId, stepId, stimId) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${studyId}/cell/${cellId}/step/${stepId}/stimuli/${stimId}/report`,
      headers: getHeaders().headers,
    });
  },
  fetchFeatureData: (studyId, cellId, stepId, stimId, filterData) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${studyId}/cell/${cellId}/step/${stepId}/stimuli/${stimId}/feature_analysis`,
      headers: getHeaders().headers,
      data: filterData,
    });
  },
  fetchFeatureRawData: (studyId, cellId, stepId, stimId) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${studyId}/cell/${cellId}/step/${stepId}/stimuli/${stimId}/feature_report`,
      headers: getHeaders().headers,
    });
  },
  loginAttempt: (username, password) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/auth-token`,
      data: { username, password },
    });
  },
  getUserData: () => {
    return axios({
      method: "get",
      url: `${URL}/v1.0/user/get-details`,
      headers: getHeaders().headers,
    });
  },
  updateUserDetails: ({
    first_name,
    last_name,
    location,
    job_title,
    phone_number,
  }) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/user/update-details`,
      data: { first_name, last_name, location, job_title, phone_number },
      headers: getHeaders().headers,
    });
  },
  fetchDemographicData: (id, data) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/participant_demographic_summary`,
      data: data,
      headers: getHeaders().headers,
    });
  },
  fetchStudies: (payloadId) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${payloadId}/overview`,
      headers: getHeaders().headers,
    });
  },
  fetchSurveyData: (id) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/survey/overview`,
      headers: getHeaders().headers,
    });
  },
  fetchStepData: (id) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/steps/overview`,
      headers: getHeaders().headers,
    });
  },
  fetchStimData: (id) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/stims/overview`,
      headers: getHeaders().headers,
    });
  },

  fetchStudySpecificStims: (id) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/stims`,
      headers: getHeaders().headers,
    });
  },

  getStepDetailInfo: (id, data) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/steps/step-detail`,
      data: data,
      headers: getHeaders().headers,
    });
  },

  getInstructionSteps: (id, data) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/steps/instruction`,
      data: data,
      headers: getHeaders().headers,
    });
  },

  getCacheSteps: (id, data) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/steps/cache`,
      data: data,
      headers: getHeaders().headers,
    });
  },

  getReusableCacheSteps: (id, data) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/steps/reusablecachepg`,
      data: data,
      headers: getHeaders().headers,
    });
  },

  getQuestionSteps: (id, data) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/steps/question`,
      data: data,
      headers: getHeaders().headers,
    });
  },

  getExternalSteps: (id, data) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/steps/external`,
      data: data,
      headers: getHeaders().headers,
    });
  },

  getEmbeddedSteps: (id, data) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/steps/embedded`,
      data: data,
      headers: getHeaders().headers,
    });
  },

  getStimSteps: (id, data) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/steps/stim`,
      data: data,
      headers: getHeaders().headers,
    });
  },
  getDistractionSteps: (id, data) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/steps/distraction`,
      data: data,
      headers: getHeaders().headers,
    });
  },
  getCommandSteps: (id, data) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/steps/command`,
      data: data,
      headers: getHeaders().headers,
    });
  },

  getValidationSteps: (id) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/steps/validation`,
      data: {},
      headers: getHeaders().headers,
    });
  },

  getCalibrationSteps: (id) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/steps/calibration`,
      data: {},
      headers: getHeaders().headers,
    });
  },

  getNextButton: () => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/dashboard/data/nextbuttontypes_list`,
      headers: getHeaders().headers,
    });
  },

  postNewStepDataToApi: async (id, data) => {
    try {
      const res = await axios({
        method: "post",
        url: `${URL}/v1.0/studies/${id}/steps/create`,
        data: data,
        headers: getHeaders().headers,
      });
      return res
    } catch (error) {

    }
    // finally {
    //   done()
    // }
  },
  postNewEmbeddedStepDataToApi: (id, data) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/embedded/steps/create/`,
      data: data,
      headers: getHeaders().headers,
    });
  },
  postNewExternalStepDataToApi: (id, data) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/external/steps/create/`,
      data: data,
      headers: getHeaders().headers,
    });
  },
  postNewDistractionStepDataToApi: (id, data) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/distraction/steps/create/`,
      data: data,
      headers: getHeaders().headers,
    });
  },
  postNewInstructionStepDataToApi: (id, data) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/instruction/steps/create/`,
      data: data,
      headers: getHeaders().headers,
    });
  },
  deleteStepFromCell: (id, data) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/steps/delete`,
      data: data,
      headers: getHeaders().headers,
    });
  },
  postStepReOrderData: (id, data) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/steps/overview/edit`,
      data: data,
      headers: getHeaders().headers,
    });
  },
  addCell: (id, data) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/cells/create`,
      data: data,
      headers: getHeaders().headers,
    });
  },
  editTask: (id, data) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/cells/edit`,
      data: data,
      headers: getHeaders().headers,
    });
  },
  editStepData: (id, data) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/steps/edit`,
      data: data,
      headers: getHeaders().headers,
    });
  },
  onAddNewStudySubmit: (data) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/create`,
      data: data,
      headers: getHeaders().headers,
    });
  },
  fetchStimsData: (data) => {
    return axios({
      method: 'post',
      url: !!data.filter_study_id ? `${URL}/v1.0/studies/${data.filter_study_id}/stims` : `${URL}/v1.0/stims`,

      headers: getHeaders().headers,
      data: data,
    });
  },
  fetchStudySpecificStims: (id) => {
    return axios({
      method: 'post',
      url: `${URL}/v1.0/studies/${id}/stims`,
      headers: getHeaders().headers,
    });
  },

  fetchSpecificStim: (id) => {
    return axios({
      method: 'get',
      url: `${URL}/v1.0/stims/${id}/details`,
      headers: getHeaders().headers,
    });
  },

  fetchBatchData: (data) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/batch/list`,
      headers: getHeaders().headers,
      data: data,
    });
  },
  fetchBatchStimsData: (data) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/batch/stimulus/discovered`,
      headers: getHeaders().headers,
      data: data,
    });
  },
  fetchBatchGraphData: (data) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/batch/report-graph`,
      headers: getHeaders().headers,
      data: data,
    });
  },
  unlockStudy: (id) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/steps/overview/edit-toggle/ `,
      headers: getHeaders().headers,
    });
  },
  getParticipantReport: (studyId, cellId, stepId) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${studyId}/cell/${cellId}/step/${stepId}/participant_report `,
      headers: getHeaders().headers,
    });
  },
  fetchAudienceOverviewData: (id) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/audience/overview `,
      headers: getHeaders().headers,
    });
  },
  fetchOverviewData: (id) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/overview `,
      headers: getHeaders().headers,
    });
  },
  createPanel: (id, data) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/audience/create `,
      headers: getHeaders().headers,
      data: data,
    });
  },
  deletePanel: (id, studyId) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${studyId}/audience/${id}/delete `,
      headers: getHeaders().headers,
    });
  },
  getPanelDetails: (id, studyId) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${studyId}/audience/${id}/details `,
      headers: getHeaders().headers,
    });
  },
  getLinksData: (id) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/links `,
      headers: getHeaders().headers,
    });
  },
  downloadReportData: (id, type) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/${type}`,
      headers: getHeaders().headers,
    });
  },
  getVendorStimList: (data) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/vendor/stimulus/list `,
      headers: getHeaders().headers,
      data: data,
    });
  },
  orderACachePage: (data) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/cachepages/order `,
      headers: getHeaders().headers,
      data: data,
    });
  },
  getFilesForStudy: (id) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/files `,
      headers: getHeaders().headers,
    });
  },
  getAllFiles: () => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/files `,
      headers: getHeaders().headers,
    });
  },
  postEndLiveStudy: (id) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/complete`,
      headers: getHeaders().headers,
    });
  },
  postAssignToAction: (id) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${id}/assign_to_action`,
      headers: getHeaders().headers,
    });
  },
  fetchReportDetails: (studyId) => {
    const baseUrl = studyId
      ? `${URL}/v1.0/studies/${studyId}`
      : `${URL}/v1.0/user`;

    return axios({
      method: "get",
      url: baseUrl + "/get-report-details",
      headers: getHeaders().headers,
    });
  },

  fetchLookerUrl: (panelUrl, studyId) => {
    const baseUrl = studyId
      ? `${URL}/v1.0/studies/${studyId}`
      : `${URL}/v1.0/user`;
    return axios({
      method: "get",
      url: baseUrl + `/get-report-url?panel_url=${panelUrl}`,
      headers: getHeaders().headers,
    });
  },

  fetchSupersetGuestToken: (dashboardId, studyId) => {
    const baseUrl = studyId
      ? `${URL}/v1.0/studies/${studyId}`
      : `${URL}/v1.0/user`;
    return axios({
      method: "get",
      url: baseUrl + `/get-report-token?dashboard_id=${dashboardId}`,
      headers: getHeaders().headers,
    });
  },

  fetchStudyDetails: (studyId) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${studyId}/details`,
      headers: getHeaders().headers,
    });
  },

  handleAutomateStudy: (studyId) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${studyId}/order_study_runthrough`,
      headers: getHeaders().headers,

    });
  },

  getStudyRunThroughs: (orderBy = "runthrough_date_desc") => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studyrunthroughs`,
      headers: getHeaders().headers,
      data: {
        order_by: orderBy
      }
    });
  },

  getStudyRunThrough: (studyRunThroughId) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studyrunthroughs/${studyRunThroughId}`,
      headers: getHeaders().headers
    })
  },

  fetchBrowserstackAutomateBuilds: (projectId) => {
    return axios({
      method: "post",
      url: `${BROWSERSTACK_API_URL}automate/builds.json?projectId=${projectId}`,
      headers: {
        auth: {
          username: BROWSERSTACK_API_UNAME,
          password: BROWSERSTACK_API_KEY,
        },
      },

    });
  },

  duplicateCell: (studyId, cellId) => {
    return axios({
      method: 'post',
      url: `${URL}/v1.0/studies/${studyId}/cells/duplicate/`,
      headers: getHeaders().headers,
      data: {
        cell_id: cellId
      }
    });
  },

  setStudyPhaseColour: (studyId, payload = "reset-to-green") => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/${studyId}/set_phase_colour/`,
      headers: getHeaders().headers,
      data:
        typeof payload === "string"
          ? { colour_command: payload }
          : payload,
    });
  },

  updateStudiesList: (studylist) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/studies/update`,
      headers: getHeaders().headers,
      data: { studylist },
    });
  },

  fetchSupersetDownloadAll: (dashboardId, studyId) => {
    const baseUrl = studyId
      ? `${URL}/v1.0/studies/${studyId}`
      : `${URL}/v1.0/user`;

    return axios({
      method: "get",
      url: `${baseUrl}/get-report-download-all/?dashboard_id=${encodeURIComponent(
        dashboardId
      )}`,
      headers: getHeaders().headers,
      responseType: "blob",
    });
  },

  getSupersetDownloadAllUrl: (dashboardId, studyId) => {
    const baseUrl = studyId
      ? `${URL}/v1.0/studies/${studyId}`
      : `${URL}/v1.0/user`;

    return `${baseUrl}/get-report-download-all/?dashboard_id=${encodeURIComponent(
      dashboardId
    )}`;
  },
  getResetToGreenReasons: () => {
    return axios({
      method: "get",
      url: `${URL}/v1.0/dashboard/data/reset_to_green_reasons_list/`,
      headers: getHeaders().headers,
    });
  },

  getAdTypeList: (orderBy) => {
    console.log("calling API with orderBy:", orderBy);
    return axios({
      method: "get",
      url: `${URL}/v1.0/dashboard/data/adtypes_list`,
      headers: getHeaders().headers,
      params: {
        order_by: orderBy
      }
    }
    );
  },

  createAdType: (data) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/dashboard/data/adtypes_list/create`,
      headers: getHeaders().headers,
      data: {
        name: data.name,
        description: data.description,
        code: data.code,
        width: Number(data.width),
        height: Number(data.height),
      }
    });
  },

  updateAdType: (id, data) => {
    console.log("calling API with id:", id, "payload:", data);
    return axios({
      method: "post",
      url: `${URL}/v1.0/dashboard/data/adtypes/${id}/update`,
      headers: getHeaders().headers,
      data: {
        ...data
      }
    });
  },

  getAdTypeGroups: async (orderBy) => {
    console.log("calling API with orderBy:", orderBy);
    try {
      const response = await axios({
        method: "get",
        url: `${URL}/v1.0/dashboard/data/adtypegroups_list`,
        headers: getHeaders().headers,
        // orderBy is optional - omit order_by entirely when no sort is requested
        ...(orderBy ? { params: { order_by: orderBy } } : {})
      });
      return response
    } catch (error) {
      console.log('error ')
      console.log(error)
      console.log('---')
    }
  },

  createAdTypeGroup: (data) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/dashboard/data/adtypegroups_list/create`,
      headers: getHeaders().headers,
      data: {
        ad_asset_type: data.ad_asset_type_id,
        name: data.name,
        description: data.description,
        code: data.code
      }
    });
  },

  updateAdTypeGroup: (id, data) => {
    console.log("calling API with id:", id);
    return axios({
      method: "post",
      url: `${URL}/v1.0/dashboard/data/adtypegroups/${id}/update`,
      headers: getHeaders().headers,
      data: {
        ad_asset_type_id: data.ad_asset_type_id,
        name: data.name,
        name_single: data.name_single,
        description: data.description,
        code: data.code
      }
    });
  },

  getAdAssetTypes: (orderBy) => {
    console.log("calling API with orderBy:", orderBy);
    return axios({
      method: "get",
      url: `${URL}/v1.0/dashboard/data/adassettypes_list`,
      headers: getHeaders().headers,
      params: {
        order_by: orderBy
      }
    }
    );
  },

  createAdAssetType: (data) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/dashboard/data/adassettypes_list/create`,
      headers: getHeaders().headers,
      data: {
        name: data.name,
        description: data.description,
      }
    });
  },

  updateAdAssetType: (id, data) => {
    console.log("calling API with id:", id);
    return axios({
      method: "post",
      url: `${URL}/v1.0/dashboard/data/adassettypes/${id}/update`,
      headers: getHeaders().headers,
      data: {
        name: data.name,
        description: data.description,
      }
    });
  },

  getAdTypeOwners: (orderBy) => {
    console.log("calling API with orderBy:", orderBy);
    return axios({
      method: "get",
      url: `${URL}/v1.0/dashboard/data/adtypeowners_list`,
      headers: getHeaders().headers,
      params: {
        order_by: orderBy
      }
    }
    );
  },

  createAdTypeOwner: (data) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/dashboard/data/adtypeowners_list/create`,
      headers: getHeaders().headers,
      data: {
        name: data.name,
        description: data.description,
        code: data.code
      }
    });
  },

  updateAdTypeOwner: (id, data) => {
    console.log("calling API with id:", id);
    return axios({
      method: "post",
      url: `${URL}/v1.0/dashboard/data/adtypeowners/${id}/update`,
      headers: getHeaders().headers,
      data: {
        ad_asset_type_id: data.ad_asset_type_id,
        name: data.name,
        description: data.description,
        code: data.code
      }
    });
  },

};
export default DataService;
